var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPurchaseSuccess(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.6693 26C47.6693 37.966 37.9687 47.6666 26.0026 47.6666C14.0364 47.6666 4.33594 37.966 4.33594 26C4.33594 14.0338 14.0364 4.33331 26.0026 4.33331C37.9687 4.33331 47.6693 14.0338 47.6693 26ZM34.7349 19.4343C35.3695 20.0689 35.3695 21.0978 34.7349 21.7323L23.9016 32.5656C23.267 33.2002 22.2382 33.2002 21.6036 32.5656L17.2702 28.2323C16.6356 27.5977 16.6356 26.5689 17.2702 25.9343C17.9048 25.2997 18.9337 25.2997 19.5683 25.9343L22.7526 29.1185L27.5947 24.2764L32.437 19.4343C33.0716 18.7997 34.1003 18.7997 34.7349 19.4343Z",
    fill: "#D4FDE7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32.4318 19.4342C33.0664 18.7997 34.095 18.7998 34.7296 19.4342C35.3643 20.0688 35.3643 21.0976 34.7296 21.7321L23.8966 32.5661C23.2621 33.2004 22.2334 33.2003 21.5988 32.5661L17.2648 28.2321C16.6305 27.5975 16.6304 26.5688 17.2648 25.9342C17.8994 25.2996 18.929 25.2996 19.5636 25.9342L22.7472 29.1188L32.4318 19.4342Z",
    fill: "#008B17"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPurchaseSuccess);
export default __webpack_public_path__ + "static/media/purchase-success.82aa165f6a5bd97b03dcd17fa2e9c2b8.svg";
export { ForwardRef as ReactComponent };